import { useTranslation } from 'react-i18next';
import { Dialog } from '@/common/components/Dialog/Dialog';
import { dismissFlow } from '@/common/layouts/FlowLayout/FlowLayout.utils';

export type TFlowLayoutDialogProps = {
  title?: string;
  message?: string;
  primaryActionLabel?: string;
  secondaryActionLabel?: string;
  onClose: () => void;
};
export function FlowLayoutDialog({
  title,
  message,
  primaryActionLabel,
  secondaryActionLabel,
  onClose,
}: TFlowLayoutDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog
      title={title ?? t('general.navigation.prompt.title')}
      message={message ?? t('general.navigation.prompt.description')}
      primaryAction={{
        children:
          primaryActionLabel ?? t('general.navigation.prompt.confirm_label'),
        onPress: () => {
          dismissFlow();
        },
      }}
      secondaryAction={{
        children:
          secondaryActionLabel ?? t('general.navigation.prompt.cancel_label'),
      }}
      onClose={onClose}
    />
  );
}
